import { createContext } from "react";
import { MemberShipContexType } from "./types/membership-context.type";


export const MemberShipContext = createContext<MemberShipContexType>({} as MemberShipContexType)